module.exports = __webpack_public_path__ + "media/goforajourney/img/barcelona/img237-f8038b331e43cab71f73a83b267a6f52.jpg";